import { createSelector } from '@ngrx/store';
import { denormalize } from 'normalizr';
import {
  ByKey,
  createListStateIdsSelector,
  createListStateParamsSelector,
  createStateErrorsSelector,
  createStateLoadingSelector,
  createStateSuccessSelector,
  IdType,
  ListState
} from '@industi/ngx-common';
import { Dictionary } from '../../../../shared/models/dictionary';
import { EntityTypes } from '../../../entity/entity-types';
import { createEntitiesSelector } from '../../../entity/entities.reducer';
import { createSymfonyTotalCountSelector } from '../../../symfony/list/selectors/list.selectors';
import { Entities } from '../../../entity/entities';
import { EntityState } from '../../../entity/entity.reducer';
import { getDictionaryCarbonMaterialTypeListState } from '../carbon-material-type.reducer';

const createState = (id: IdType) => createSelector(
  getDictionaryCarbonMaterialTypeListState,
  (state: ByKey<ListState>) => state && state[id]
);

const createStateByContext = (id: IdType) => createListStateIdsSelector(createState(id));

export const createDictionaryCarbonMaterialTypeListData = (id: IdType) => createSelector(
  createStateByContext(id),
  createEntitiesSelector([
    EntityTypes.carbonMaterialType
  ]),
  (
    ids: IdType[],
    entities: EntityState
  ) => denormalize(ids, [Entities[EntityTypes.carbonMaterialType]], entities) as Dictionary[]
);

export const createDictionaryCarbonMaterialTypeListLoading = (id: IdType) => createStateLoadingSelector(
  createState(id));

export const createDictionaryCarbonMaterialTypeListSuccess = (id: IdType) => createStateSuccessSelector(
  createState(id));

export const createDictionaryCarbonMaterialTypeListErrors = (id: IdType) => createStateErrorsSelector(
  createState(id));

export const createDictionaryCarbonMaterialTypeListTotalCount = (id: IdType) => createSymfonyTotalCountSelector(
  createState(id));

export const createDictionaryCarbonMaterialTypeListParams = (id: IdType) => createListStateParamsSelector(
  createState(id));
